const ForwardRef = (Component) =>
  function forwardRef(props, ref) {
    return <Component {...props} forwardedRef={ref} />;
  };

export default ForwardRef;
